import { useState } from "react";
import Breadcrumb from "@/components/base/Breadcrumb";
import NewsListItem from "@/components/base/NewsListItem";
import Pagination from "@/components/base/Pagination";
import { news } from "@/mocks/news";

const PAGE_SIZE = 6;

export default function News() {
  const [page, setPage] = useState(1);
  const totalPages = Math.ceil(news.length / PAGE_SIZE);
  const items = news.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);

  return (
    <div className="w-full px-4 md:px-8 py-6 md:py-8">
      <Breadcrumb items={[{ label: "影视资讯" }]} />

      <div className="mt-4 rounded-lg bg-primary-950 px-6 py-8 md:py-10 relative overflow-hidden">
        <div className="relative z-10">
          <h1 className="text-2xl md:text-4xl font-heading font-bold text-background-50">
            最新影视资讯
          </h1>
          <p className="mt-2 text-sm md:text-base text-background-200 max-w-2xl">
            获取最新影视动态与资讯内容，涵盖电影新闻、电视剧发展动向与影评推荐。
          </p>
        </div>
        <i className="ri-newspaper-line absolute -right-4 -bottom-6 text-[120px] text-primary-900"></i>
      </div>

      {items.length === 0 ? (
        <div className="mt-8 rounded-lg bg-background-50 border border-background-200 py-16 flex flex-col items-center">
          <i className="ri-file-list-3-line text-5xl text-background-400"></i>
          <p className="mt-4 text-sm text-foreground-600">暂无最新资讯</p>
        </div>
      ) : (
        <>
          <div className="mt-6 flex flex-col gap-3">
            {items.map((item) => (
              <NewsListItem key={item.id} item={item} />
            ))}
          </div>
          <Pagination
            current={page}
            total={totalPages}
            onChange={(p) => {
              setPage(p);
              window.scrollTo({ top: 0, behavior: "smooth" });
            }}
          />
        </>
      )}
    </div>
  );
}